export default "__VITE_ASSET__Dz3wZnM6__"